import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(username, password);
    
      nav("/dashboard");
    } catch (e2) {
      setErr(String(e2?.response?.data || "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 20 }}>
      <form onSubmit={submit} style={{ width: 360, border: "1px solid #ddd", borderRadius: 12, padding: 18 }}>
        <h2 style={{ marginTop: 0 }}>Admin Login</h2>

        {err && (
          <div style={{ background: "#fee", border: "1px solid #fbb", padding: 10, borderRadius: 10 }}>
            {err}
          </div>
        )}

        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 12, opacity: 0.7 }}>Username</div>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ width: "100%", padding: 10 }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 12, opacity: 0.7 }}>Password</div>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", padding: 10 }}
          />
        </div>

        <button disabled={loading} style={{ marginTop: 14, width: "100%", padding: 10 }}>
          {loading ? "Signing in..." : "Login"}
        </button>
      </form>
    </div>
  );
}
